var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFood(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 48,
    viewBox: "0 -960 960 960",
    width: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m164.717-107.13-54.108-54.109L535.13-586.761q-20.521-47.913-6.684-101.674 13.837-53.761 58.402-99.043 47.087-46.087 115.022-59.261 67.934-13.174 111.847 30.5 43.913 43.913 30.5 111.728-13.413 67.815-62.5 117.902-41.043 43.044-94.184 56.881-53.142 13.837-97.294-3.924l-57.369 58.13 314.282 314.283-54.109 54.109L479-421.413 164.717-107.13Zm121.174-358.631L165.043-586.609q-56.673-56.152-56.239-130.771.435-74.62 54.153-133.294L417-596.87 285.891-465.761Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFood);
export default __webpack_public_path__ + "static/media/food.056cf7becbf615a345833bfd6f9057f7.svg";
export { ForwardRef as ReactComponent };